import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7ee8edc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lottie-container" }
const _hoisted_2 = ["id", "src"]
const _hoisted_3 = ["id", "src"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-lottie-animation',
  props: {
    src: {},
    reverseSrc: {},
    id: {},
    containerId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const lottie = ref();
const lottieReversed = ref();

const lottieIsReversed = ref(false);

function playAnimation(isReversed: boolean): void {
  lottieIsReversed.value = isReversed && !!props.reverseSrc;
  if (lottieIsReversed.value) {
    lottieReversed.value.seek("99%");
    lottieReversed.value.setDirection(-1);
    lottieReversed.value.play();
  } else {
    lottie.value.seek("0%");
    lottie.value.setDirection(1);
    lottie.value.play();
  }
}

__expose({
  playAnimation,
  lottie,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("lottie-player", {
      class: _normalizeClass({ hidden: !lottieIsReversed.value }),
      ref_key: "lottieReversed",
      ref: lottieReversed,
      id: props.id,
      src: props.reverseSrc
    }, null, 10, _hoisted_2),
    _createElementVNode("lottie-player", {
      class: _normalizeClass({ hidden: lottieIsReversed.value }),
      ref_key: "lottie",
      ref: lottie,
      id: props.id,
      src: _ctx.src
    }, null, 10, _hoisted_3)
  ]))
}
}

})